import { all } from 'redux-saga/effects';
import {
  preferencesSagas,
  userSagas,
  parametersSagas,
  reportSagas,
  errorSagas,
  dashboardSagas,
  exportsSagas,
  reprocessSagas,
  synchroSagas,
  managementReportSagas,
  parametricStoresSagas,
} from '../../state';

export default function* rootSagas() {
  yield all([
    ...preferencesSagas,
    ...userSagas,
    ...parametersSagas,
    ...reportSagas,
    ...errorSagas,
    ...dashboardSagas,
    ...exportsSagas,
    ...reprocessSagas,
    ...synchroSagas,
    ...managementReportSagas,
    ...parametricStoresSagas,
  ]);
}
